import { http } from 'utils'
import { SET_XERO_LINK, SET_XERO_DATA } from 'vx/mutations'

// Settings state.
const state = {
  data: {},
  link: null
}

// User state getters.
const getters = {}

// user actions.
const actions = {
  /**
   * Get Xero OAuth2 link url
   *
   * @return Promise
   */
  getConnection ({ commit }) {
    return http.get('/xero-connection').then(response => {
      if (response.data) {
        commit(SET_XERO_DATA, response.data.data)
      }

      return response
    })
  }
}

// Setting state mutations.
const mutations = {
  [SET_XERO_LINK] (state, link) {
    state.link = link
  },

  [SET_XERO_DATA] (state, data) {
    state.data = data
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
